<template>
  <footer class="footer">

      <div class="credits">

        <div class="mreze">
          <i class="fab fa-facebook-square"></i>
          <i class="fab fa-instagram"></i>
          <i class="fab fa-twitter"></i>
          <i class="fab fa-linkedin-in"></i>
        </div>
        <div class="generalije">
          <p>Virginia d.o.o. Surčinski put 21, Novi Beograd</p>
          <p>Tel: 011 22 60 116, 22 69 043 * Fax: 011 22 60 114</p>
          <p>E-mail: office@virginia.rs</p>
          <!-- <p>Ovlašćeni distributer Pindstrup, ICL SF, Nirit Seeds, Biobest, Politiv programa.</p> -->
        </div>
        <p>&copy; Copyright by Virginia® d.o.o.</p>
      </div>

      <!-- <div v-if="lang=='srb'" class="news">
        <span>Newsletter</span>
        <p>Prijavite se da primate obaveštenja o promocijama i novostima</p>
        <form class="place">
            <div class="form-row">
              <input class="inp" id="lastname" type="text" v-model="newsemail" required>
              <label class="placehold" for="lastname">Unesi E-mail adresu</label>
              <button @click="sendemail()">Pošalji ></button>
            </div>


        </form>

      </div> -->

      <div class="coockies" >
        <p>Ovaj sajt koristi Google Analytics <span @click="sendurlsrb()">Pročitaj više</span></p>
      </div>
  </footer>

</template>

<script>
	import {mapGetters, mapActions, mapMutations} from 'vuex'

export default {

  data () {
    return {
        newsemail:null
    }

    },
    methods:{
      ...mapActions([
        'news'

      ]),
      validemail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
      },
      sendemail(){
        if(this.newsemail){
          this.news(this.newsemail)
          console.log(this.newsemail);
            }else{
              alert('invalid email');
              return;
          }

      },
      sendurlsrb(){
        window.open("https://policies.google.com/technologies/partner-sites?hl=sr")
      },

    },
    computed:{
      ...mapGetters([
          'lang'
      ]),

    }

  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/myfooter.vue